import { gql } from "@apollo/client";

export const LIST_TEMPLATE_FONTS = gql`
  query listTemplateFonts {
    listTemplateFonts {
      totalCount
      results {
        name
        id
        url
      }
    }
  }
`;

export const GET_COMPANY_INVOICE_DESIGN = gql`
  query getCompanySaleDocumentDesign($companyId: ID!) {
    getCompanySaleDocumentDesign(companyId: $companyId) {
      saleDocumentTemplate {
        id
      }
      fontId
      titleColor
      baseColor
      baseTextColor
      baseTextColorBackground
      logoDescription
      logoUrl
      templateLanguage
      note
      previewUrl
      backgroundImageUrl
      backgroundImageOpacity
      logoPosition {
        label
        value
      }
      tableBorder {
        label
        value
      }
      discount
      fixedRecoveryFee
      latePaymentPenalty
    }
  }
`;

export const GET_COMPANY_INVOICE_DESIGN_DEFAULTS = gql`
  query getCompanySaleDocumentDesign($companyId: ID!) {
    getCompanySaleDocumentDesign(companyId: $companyId) {
      note
      discount
      fixedRecoveryFee
      latePaymentPenalty
    }
  }
`;

export const GET_COMPANY_INVOICE_DESIGN_UPDATED_DATE = gql`
  query getCompanySaleDocumentDesign($companyId: ID!) {
    getCompanySaleDocumentDesign(companyId: $companyId) {
      updatedAt
    }
  }
`;

export const UPDATE_COMPANY_INVOICE_DESIGN = gql`
  mutation updateCompanySaleDocumentDesign(
    $companyId: ID!
    $template: ID
    $logo: Upload
    $backgroundImage: Upload
    $logoDescription: String
    $font: ID
    $titleColor: String
    $baseColor: String
    $baseTextColor: String
    $backgroundImageOpacity: Float
    $tableBorder: String
    $logoPosition: String
    $baseTextColorBackground: String
    $templateLanguage: String
    $note: String
    $latePaymentPenalty: String!
    $fixedRecoveryFee: String!
    $discount: String!
    $removeLogo: Boolean
    $removeBackgroundImage: Boolean
  ) {
    updateCompanySaleDocumentDesign(
      input: {
        companyId: $companyId
        saleDocumentTemplate: $template
        logo: $logo
        backgroundImage: $backgroundImage
        logoDescription: $logoDescription
        font: $font
        titleColor: $titleColor
        baseColor: $baseColor
        baseTextColor: $baseTextColor
        backgroundImageOpacity: $backgroundImageOpacity
        tableBorder: $tableBorder
        logoPosition: $logoPosition
        baseTextColorBackground: $baseTextColorBackground
        templateLanguage: $templateLanguage
        note: $note
        latePaymentPenalty: $latePaymentPenalty
        fixedRecoveryFee: $fixedRecoveryFee
        discount: $discount
        removeLogo: $removeLogo
        removeBackgroundImage: $removeBackgroundImage
      }
    ) {
      companySaleDocumentDesign {
        previewUrl
      }
      success
      errors {
        messages
        field
      }
    }
  }
`;

export const SEND_PAYMENT_EMAIL = gql`
  mutation sendPaymentEmail($input: SendPaymentEmailInput!) {
    sendPaymentEmail(input: $input) {
      errors {
        field
        messages
      }
      success
    }
  }
`;
